/**
 * Creato per poter gestire il reroute nel dump dello store.
 * il reroute deve essere sempre la rotta piu' lontanta in cui l'utente e' stato
 * */

export const ROUTES = {
  REGISTER: '/register',
  CART: '/cart',
  SERVIZI_AGGIUNTIVI_USATO: '/servizi',
  CHECKOUT: '/checkout',
  DATI: '/dati',
  DATI_FINANZIAMENTO: '/dati-finanziamento',
  RIEPILOGO_FINANZIAMENTO_FINDOMESTIC: '/riepilogo-finanziamento-findomestic',
  DOCUMENT_COMPASS: '/document-compass',
  SERVIZI_PLUS: '/servizi-plus',
  PREVIEW_CONTRATTO: '/preview-contratto',
  BONIFICO: '/bonifico',
  BONIFICO_READY_FOR_DOCS: '/bonifico-ready-for-docs',
  SCEGLI_CANONE: '/scegli-canone',
  RICHIESTA_NOLEGGIO: '/richiesta-noleggio',
  DOCUMENTS: '/documents',
  DOCUMENTS_FINDOMESTIC: '/documents-findomestic',
  THANK_YOU: '/thank-you',
  THANK_YOU_NLT_BB_FIRMA_COMPLETATA: '/thank-you-firma-completata',
  THANK_YOU_FINDOMESTIC: '/thank-you-findomestic',
  CERTIFICATO_INFOCERT: '/certificato-infocert',
  CERTIFICATO_INFOCERT_V2: '/v2/certificato-infocert',
  CREA_PIN: '/crea-pin',
  CONTRATTO_INFOCERT: '/contratto-infocert',
  CONTRATTO_INFOCERT_V2: '/v2/contratto-infocert',
  CONTRATTO_FINDOMESTIC: '/contratto-findomestic',
  CONTRATTO_FINDOMESTIC_V2: '/v2/contratto-findomestic',
  FIRMA_SERVIZI_ASSICURATIVI: '/firma-servizi-assicurativi',
  FIRMA_SERVIZI_ASSICURATIVI_V2: '/v2/firma-servizi-assicurativi',
  FIRMA_DIGITALE: '/firma-digitale',
  FIRMA_DIGITALE_V2: '/v2/firma-digitale',
  FIRMA_NLT_BRUMBRUM_LANDING: '/firma-nlt-brumbrum/landing',
  FIRMA_NLT_BRUMBRUM: '/firma-nlt-brumbrum',
  FIRMA_NLT_BRUMBRUM_THANK_YOU: '/firma-nlt-brumbrum/thank-you',
  THANK_YOU_FIRMA: '/thank-you-firma',
}

const routes = [
  { url: ROUTES.REGISTER },
  { url: ROUTES.CART },
  { url: ROUTES.SERVIZI_AGGIUNTIVI_USATO },
  { url: ROUTES.CHECKOUT },
  { url: ROUTES.DATI },
  { url: ROUTES.DATI_FINANZIAMENTO },
  { url: ROUTES.RIEPILOGO_FINANZIAMENTO_FINDOMESTIC },
  { url: ROUTES.DOCUMENT_COMPASS },
  { url: ROUTES.PREVIEW_CONTRATTO },
  { url: ROUTES.BONIFICO },
  { url: ROUTES.BONIFICO_READY_FOR_DOCS },
  { url: ROUTES.SCEGLI_CANONE },
  { url: ROUTES.SERVIZI_PLUS },
  { url: ROUTES.RICHIESTA_NOLEGGIO },
  { url: ROUTES.DOCUMENTS },
  { url: ROUTES.DOCUMENTS_FINDOMESTIC },
  { url: ROUTES.THANK_YOU },
  { url: ROUTES.THANK_YOU_NLT_BB_FIRMA_COMPLETATA },
  { url: ROUTES.THANK_YOU_FINDOMESTIC },
  { url: ROUTES.CERTIFICATO_INFOCERT },
  { url: ROUTES.CERTIFICATO_INFOCERT_V2 },
  { url: ROUTES.CREA_PIN },
  { url: ROUTES.CONTRATTO_INFOCERT },
  { url: ROUTES.CONTRATTO_INFOCERT_V2 },
  { url: ROUTES.CONTRATTO_FINDOMESTIC },
  { url: ROUTES.CONTRATTO_FINDOMESTIC_V2 },
  { url: ROUTES.FIRMA_SERVIZI_ASSICURATIVI },
  { url: ROUTES.FIRMA_SERVIZI_ASSICURATIVI_V2 },
  { url: ROUTES.FIRMA_DIGITALE },
  { url: ROUTES.FIRMA_DIGITALE_V2 },
  { url: ROUTES.FIRMA_NLT_BRUMBRUM_LANDING, isExternal: true },
  { url: ROUTES.FIRMA_NLT_BRUMBRUM, isExternal: true },
  { url: ROUTES.FIRMA_NLT_BRUMBRUM_THANK_YOU, isExternal: true },
  { url: ROUTES.THANK_YOU_FIRMA },
]

export function findRoute(lookupRoute) {
  return routes.find(route => route.url === lookupRoute)
}

export function findRouteIndex(lookupRoute) {
  return routes.findIndex(route => route.url === lookupRoute)
}

export default routes
